import React from 'react'
import { compose, withState, withHandlers } from 'recompose'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Filter from './Filter'
import FilterActions from './FilterActions'
import CardContent from '@mui/material/CardContent'

export const getDomainNameHeader = searchText => {
	if (searchText.text == null || searchText.text == '') return 'All domains'
	else return 'Domains containing "' + searchText.text + '"'
}

export const DomainNameFilter = ({ search, searchText, setSearchText, onSave, onCancel }) => (
	<Filter
		filterObj={search.filter.searchText}
		filterState={searchText}
		setFilterState={setSearchText}
		title="Search domain names"
		subtitle={getDomainNameHeader(searchText)}
		content={
			<CardContent style={{ padding: '0px' }}>
				<div style={{ padding: '31px 44px 39px', borderTopRightRadius: '0px', borderTopLeftRadius: '0px' }}>
					<Typography>Display whitelisted email domains containing:</Typography>
					<TextField
						id="search-text-field"
						label="Search"
						variant='filled'
						value={searchText.text || ''}
						onChange={(e, v) => setSearchText({ ...searchText, text: e.target.value, expanded: true })}
						onKeyPress={ev => {
							if (ev.key === 'Enter') {
								onSave()
							}
						}}
					/>
				</div>
				<FilterActions
					expanded={searchText.expanded}
					primaryLabel="Save"
					primaryAction={onSave}
					secondaryLabel="Cancel"
					secondaryAction={onCancel}
				/>
			</CardContent>
		}
	/>
)

const enhance = compose(
	withState('searchText', 'setSearchText', ownProps => ownProps.search.filter.searchText),
	withHandlers({
		onSave: props => () => {
			let updated = {
				...props.search,
				filter: { ...props.search.filter, searchText: { ...props.searchText, expanded: false } },
			}
			props.onUpdate(updated)
			props.setSearchText(updated.filter.searchText)
		},
		onCancel: props => () => {
			props.setSearchText({ ...props.search.filter.searchText, expanded: false })
		},
	})
)

export default enhance(DomainNameFilter)
